import { Mv_Sketch } from './../model/water-record-model';
import { DataServiceService } from './../service/data-service.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
   AnnounceList = new Array<Mv_Sketch>();
   ModalData = new Mv_Sketch();
   AnnounceLoad: boolean;
  Total:number;
  constructor(private dataServiceService: DataServiceService) { }

  ngOnInit() {
    this.searchAnnouce();
  }
  searchAnnouce() {
    this.AnnounceLoad = true;
    this.dataServiceService.getAnnounceByDate(-1,"").subscribe(r => {
      this.AnnounceLoad = false;
      this.AnnounceList = r;

    });
  }


  openModal(item: any) {
    this.ModalData = item;
  }
}
